import React from "react";
import { CardContainer, CardWrapper } from "./style";

const Index = props => {
  return (
    <CardWrapper>
      <CardContainer onClick={props.onClick}>
        <div
          className="right-text"
          dangerouslySetInnerHTML={{ __html: props.rightTitle || "" }}
        />
        <div
          className="left-text"
          dangerouslySetInnerHTML={{ __html: props.leftTitle || "" }}
        />
      </CardContainer>
      {props.description && <div className="description">
          <i className="icon mapsa-asterisk"/>
          {props.description}
      </div>}
    </CardWrapper>
  );
};

export default Index;
